import { FmsApi } from "../fmsapi"
import type { COM_sd_BANK, COM_sd_MasterCode, COM_sd_Region, MasterCode } from "../models/responsedto"
import BaseController from "./base"

export class CommonController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "commons")
  }

  public async MasterCode(masterCodeGroupId: number): Promise<MasterCode[]> {
    return await this.getCallApi(`MasterCode/${masterCodeGroupId}`)
  }

  public async COM_sd_MasterCode(level?: string | null, masterCode?: number | null): Promise<COM_sd_MasterCode[]> {
    return await this.callApi("COM_sd_MasterCode", { level, masterCode })
  }

  public async COM_sd_Region(level: number, masterCode?: string | null): Promise<COM_sd_Region[]> {
    return await this.callApi("COM_sd_Region", { level, masterCode })
  }

  public async COM_sd_BANK(pg_type: string | null): Promise<COM_sd_BANK[]> {
    return await this.callApi("COM_sd_BANK", { pg_type })
  }
}
